import React from 'react';
import { Formik, Form } from 'formik';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { get } from 'lodash';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import { resolveTo, initFormValues, permitCheck } from '~/commons/helpers';

import FormHttpAlert from '~/commons/components/FormHttpAlert.jsx';
import FormHttpSaveBtn from '~/commons/components/FormHttpSaveBtn.jsx';
import FormErrorAlert from './FormErrorAlert.jsx';
import links from '../layout/NavList';

const FormResource = ({
  stored,
  schema,
  defaults,
  api,
  children,
  initialValuesOpts,
  formStatus = {},
  segment = '',
  forceReload = false,
  onSubmit = (v) => v,
  onSubmitDone = (v) => v,
}) => {
  const history = useHistory();
  const { path } = useRouteMatch();
  const edit = permitCheck(links, path, segment) ? {} : { disabled: true };

  const [res, req] = useHttpStatus({
    onSuccess({ data }) {
      if (!stored?._id) {
        history.push(resolveTo(`../${data[0]._id}`));
      } else if (forceReload) {
        window.location.reload();
      }
    },
  });

  return (
    <Formik
      validationSchema={schema}
      initialStatus={{ ...edit, ...formStatus }}
      initialValues={initFormValues(defaults, stored, initialValuesOpts)}
      onSubmit={async (values, actions) => {
        const id = get(stored, '_id');
        const {status, payload} = await req({
          method: id ? 'patch' : 'post',
          url: `${api}${id ? `/${id}` : ''}`,
          data: onSubmit(values),
        });

        if (status === 'success') {
          actions.setSubmitting(false);
          actions.resetForm({ values: onSubmitDone(values, payload) });
        }
      }}>
      {(props) => (
        <Form>
          <FormHttpAlert res={res} />
          <FormErrorAlert {...props} />
          <FormHttpSaveBtn res={res} className="btn-primary mb-3" />
          {typeof children === 'function' ? children(props) : children}
        </Form>
      )}
    </Formik>
  );
};

export default FormResource;
